import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postAppointmentConfig } from "apis";
import { getQueueConfigQueryKey } from "./get-queue-config";

const usePostAppointmentConfig = () => {
  const queryClient = useQueryClient();
  return useMutation(postAppointmentConfig, {
    onSuccess: () => queryClient.invalidateQueries(getQueueConfigQueryKey()),
  });
};

export default usePostAppointmentConfig;
